<style lang="sass">
@import ~bi/utilities
@import ~bi/brand/variables
@import ./src/assets/sass/m3_variables
@import ./src/assets/sass/m3_forms
</style>

<template>
    <div class="g_radiobutton g_placeholder" :class="['g_' + (data.id), {g_required: data.required, g_more: displayMore(), g_nomargin: nomargin}]">
        <legend v-if="data.label">
            <Paragraph :content="data.label" size="L" :class="'g_label'"/>
        </legend>
        <div class="g_radiobuttons" :class="{g_error: data.error, g_filled: value !== ''}">
            <div v-for="(radio, j) in data.options" :key="j" class="g_radioItem">
                <input
                    v-bind:value="radio.content"
                    v-on:input="$emit('input', $event.target.value)"
                    :id="[data.id + j]"
                    :name="data.id"
                    type="radio" />
                <label :for="[data.id + j]" v-html="radio.content"/>
            </div>
        </div>
        <span v-html="data.error" class="g_error" />
    </div>
</template>

<script>
import Vue from 'vue'
import Resource from 'vue-resource'
Vue.use(Resource)

export default {
    name: 'radiobuttons',
    props: {
        value: {
            type: String,
            default: ''
        },
        data: {
            type: Object,
            required: true
        },
        more: {
            type: Boolean,
            default: false
        },
        nomargin: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        displayMore () {
            return (this.more) && (this.value === this.data.options[0].content)
        }
    }
}
</script>
